<template>
	<div>
		L'audit 1 est clos, vous pouvez continuer votre formation en cliquant sur le bouton "Suivant" en bas à droite.
	</div>
</template>

<script>
    export default {
               mounted()       {
                       window.parent.postMessage("Audit 1", "*");
               },
    };
</script>



<style scoped>
div {
	position: absolute;
	text-align: center;
	margin-top: 20%;
	font-weight: bolder;
	font-size: x-large;
	height: 300px;
}
</style>
